
export default() =>({

    show: false,
    dropDownShow: false,
    canvas: null,
    objectType: null,
    uploadingImage: false,
    uploadingProgress: 0,

    editText() {
        this.$dispatch('modalcanvas:open', { title: 'Editar texto', setCanvas: this.canvas })
    },

    deleteObject(e, confirmation = null) {

        if (confirmation === null)
        {
            this.$dispatch('confirmation:open', { message: 'Tem certeza que deseja apagar?', callback: 'nav:delete' });
            return;
        }

        if (this.canvas) {
            const activeObject = this.canvas.getActiveObject();
            this.canvas.remove(activeObject);
            this.show = false;
        }
    },

    cloneObject() {
        if (this.canvas) {
            const activeObject = this.canvas.getActiveObject();
            activeObject.clone( (obj) => {
                obj.set('top', obj.top+5);
                obj.set('left', obj.left+5);
                this.canvas.add(obj);
            });
        }
    },

    clipImage() {
        this.$refs.inputImage.click();
    },

    uploadClippingImage() {
        const self = this;
        const file = this.$refs.inputImage.files[0];

        const formData = new FormData();
        formData.append('image', file);
        formData.append('dir', drawCanvasInitData.dir);
        formData.append('templateKey', drawCanvasInitData.templateKey);

        axios.post('api/v1/canvas/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function(progressEvent) {
                const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                self.uploadingImage = true;
                self.uploadingProgress = progress + '%';
            }
        })
            .then(function(response) {
                 self.uploadingImage = false;

                const urlImageName = response.data.name;
                self.$dispatch('uploadImage', { url: urlImageName });

            })
            .catch(function(error) {
                self.uploadingImage = false;
                console.error(error);
            });





    },

    bringToFront () {
        const activeObject = this.canvas.getActiveObject();
        activeObject.bringToFront();
    },

    bringToBack () {
        const activeObject = this.canvas.getActiveObject();
        activeObject.sendToBack();
    }

});
